import { Component, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, iif, of, switchMap, takeUntil, tap } from 'rxjs';
import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteMunicipalitySuggestionService } from 'src/app/shared/common-features/services/autocomplete-strategies/autocomplete-municipality-suggestion.service';

@Component({
    selector: 'app-municipality-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: MunicipalityAutocompleteComponent
        },
    ],
    standalone: false
})
export class MunicipalityAutocompleteComponent extends AutocompleteComponent implements OnInit {

  @Input() provinceId: number | undefined | null

  constructor(private readonly autocompleteMunicipalitySuggestionService: AutocompleteMunicipalitySuggestionService) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit()

    this.suggestions$ = this.inputControl.valueChanges.pipe(
      debounceTime(this.debounceTime),
      filter(input => !this.isSuggestion(input)),
      distinctUntilChanged(),
      tap(() => this.isLoading$.next(true)),
      tap(() => {
        if (!this.isLastEmittedValueNull) this.selectedSuggestion.emit(null)
        this.isLastEmittedValueNull = true
      }),
      switchMap(input =>
        this.autocompleteMunicipalitySuggestionService.loadSuggestions$(input as string ?? '', this.maxSuggestions, this.provinceId ?? undefined).pipe(takeUntil(this.undoClick$)),
      ),
      tap(() => { this.isLoading$.next(false) }),
    )
  }
}
